import { defineSlotRecipe } from "@chakra-ui/react";
export const nativeSelectRecipe = defineSlotRecipe({
    className: "chakra-native-select",
    slots: ["root", "field", "indicator"],
    base: {
        root: {
            position: "relative",
            display: "inline-block",
            width: "100%",
            colorPalette: "primary",
        },
        field: {
            appearance: "none",
            width: "100%",
            cursor: "pointer",
            paddingRight: "2.5rem", // Make space for the indicator
            _disabled: {
                opacity: 0.4,
                cursor: "not-allowed",
            },
        },
        indicator: {
            position: "absolute",
            top: "50%",
            right: "3",
            transform: "translateY(-50%)",
            pointerEvents: "none",
            color: "fg.subtle",
            zIndex: 1,
        },
    },
    variants: {
        variant: {
            outline: {
                field: {
                    rounded: "md",
                    borderWidth: "1px",
                    borderColor: "border",
                    bg: "bg",
                    _hover: {
                        borderColor: "border.emphasized",
                    },
                    _focus: {
                        outline: "2px solid",
                        outlineOffset: "0.5px",
                        outlineColor: "colorPalette.focusRing/15",
                        zIndex: 1,
                        borderColor: "colorPalette.focusRing",
                        boxShadow: "0 0 0 1px var(--chakra-colors-colorPalette-focusRing)",
                    },
                    _disabled: {
                        opacity: 0.4,
                        cursor: "not-allowed",
                    },
                    _invalid: {
                        borderColor: "border.error",
                        _focus: {
                            borderColor: "border.error",
                            boxShadow: "0 0 0 1px var(--chakra-colors-border-error)",
                        },
                    },
                },
            },
        },
    },
    defaultVariants: {
        variant: "outline",
    },
});
